import { render, staticRenderFns } from "./controls.vue?vue&type=template&id=19240e57&lang=pug&"
import script from "./controls.vue?vue&type=script&setup=true&lang=js&"
export * from "./controls.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./controls.vue?vue&type=style&index=0&id=19240e57&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports